/* The same silent loop used on the home page, with a static fallback. */
(() => {
  document.querySelectorAll('[data-db-video-container]').forEach((container) => {
    const video = container.querySelector('[data-db-loop]');
    const source = video?.querySelector('source[data-src]');
    const button = container.querySelector('[data-db-video-toggle]');
    if (!video || !source || !button || video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    let failed = false;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const updateControl = () => {
      button.textContent = video.paused ? 'Reproducir video' : 'Pausar video';
      button.setAttribute('aria-label', video.paused ? 'Reproducir video sin sonido de Alejandro' : 'Pausar video de Alejandro');
    };
    const useFallback = () => {
      failed = true;
      video.pause();
      video.autoplay = false;
      container.classList.remove('db-video-ready');
      button.hidden = true;
    };
    const play = (automatic = false) => {
      if (failed || (automatic && (reducedMotion.matches || userPaused))) return;
      video.autoplay = automatic;
      if (!source.hasAttribute('src')) {
        source.src = source.dataset.src;
        video.load();
      }
      video.muted = true;
      const started = video.play();
      if (started && typeof started.catch === 'function') {
        started.catch(() => {
          if (video.error) useFallback();
          else updateControl();
        });
      }
    };

    video.addEventListener('playing', () => {
      container.classList.add('db-video-ready');
      updateControl();
    });
    video.addEventListener('pause', updateControl);
    video.addEventListener('error', useFallback);
    source.addEventListener('error', useFallback);
    button.addEventListener('click', () => {
      if (video.paused) {
        userPaused = false;
        play(false);
      } else {
        userPaused = true;
        video.autoplay = false;
        video.pause();
      }
    });
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) {
        video.autoplay = false;
        video.pause();
      } else if (!userPaused) {
        play(true);
      }
    });
    button.hidden = false;
    updateControl();
    // Do not request the video until motion is permitted or the visitor opts in.
    if (!reducedMotion.matches) play(true);
  });
})();
